import { Helmet } from "react-helmet-async";

const SeoHelmet = ({
  title = "SunMed | Media Production, Web Solutions, Digital Marketing, Education & Event Management",
  description = "SunMed: شريكك الموثوق في الإعلام الرقمي، تطوير المواقع، التسويق الإلكتروني، التعليم، وإدارة الفعاليات. نقدم حلولاً مبتكرة تساعد أعمالك على النمو والتميز.",
  keywords = "SunMed, media production, web solutions, digital marketing, education, event management, إنتاج إعلامي, تسويق إلكتروني, تطوير مواقع, خدمات تعليمية, إدارة فعاليات, برمجة مواقع, تصميم جرافيك, حلول رقمية",
  image = "https://sunmed.com/images/sunmed-og.jpg",
  url = "https://sunmed.com",
  type = "website",
  locale = "en",
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="SunMed Company" />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="SunMed" />
      <meta property="og:locale" content={locale === 'ar' ? 'ar_AR' : 'en_US'} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@SunMed" />
    </Helmet>
  );
};

export default SeoHelmet;
